// Dependencies
import React from 'react';
import _ from 'lodash';
import { Helpers } from '../../utils';

// Types
import styled, { css, useTheme } from 'styled-components';


// TODO: Refactor, optimise
export const Price = ({price, priceTaxClass, taxable, pricePerUnitThreshold = -1, quantity, config: {general: {decimals, tax, currency, roundingPrecision}}, translations}: any) => {

	const { components }: any = useTheme();

	const priceArgs = {
		quantity,
		displayMode: _.isBoolean(taxable) ? (taxable ? 'include' : 'exclude') : null ?? tax.displayMode,
		taxClass: priceTaxClass ?? tax.default,
		taxRates: tax.rates,
		precision: Math.abs(roundingPrecision),
		isOnSale: price?.sale && price.sale < price.regular
	}
	// TODO: Refactor, optimise
	const prices = { 
		newPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs, quantity: 1}) || 0,
		oldPrice: (priceArgs.isOnSale) ? Helpers.getPrice({price: price.regular, ...priceArgs, quantity: 1}) : 0 || 0, 
		currentPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs}) || 0,
		currentOldPrice: (priceArgs.isOnSale) && price.regular ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0 || 0
	}

	if ( ! price?.regular && ! price?.sale ) {
		return null;
	}
 
	// TODO: Pad zeros when they should be there (resets when some state changes) > 19.00 >> 19
	const getFormattedPrice = (type: 'oldPrice' | 'newPrice' | 'currentPrice' | 'currentOldPrice') => Helpers.getRoundedPrice(prices[type], priceArgs.precision).toFixed(decimals).replace('.', ',');
	
	return ( 
		<PriceWrapper>
			{price?.sale && price.sale < price.regular && 
				<DisplayPrice {...{type: 'original', currency}}>{ getFormattedPrice('currentOldPrice') }</DisplayPrice>
			}
			<DisplayPrice {...{type: 'current', currency}}>{ getFormattedPrice('currentPrice') }</DisplayPrice>

			{ pricePerUnitThreshold > 0 &&
				<PricePerUnit visible={quantity > 1}>
					<div>
						<strong>{`${translations.product.pricePerUnit}: `}</strong>
						{price?.sale && price.sale < price.regular && <DisplayPrice {...{type: 'original', currency}}>{ getFormattedPrice('oldPrice') }</DisplayPrice> }
						<DisplayPrice {...{type: 'current', currency}}>{ getFormattedPrice('newPrice') }</DisplayPrice>
					</div>
				</PricePerUnit>
			}

		</PriceWrapper>
	)
}

// TODO: Universal price display (type, value, currency, animated, ...)

export const PriceWrapper = styled.div<any>(
({ theme: { general, components: {price: style} } }) => css`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: center;
	text-align: right;
	font-size: 100%;
`);


export const CurrentPrice = styled.ins<any>(
({ theme: { general, components: {price: style} } }) => css`
	${Helpers.clamp('font-size', 1, 1.15)};
	font-weight: 600;
	line-height: 1;
	text-decoration: none;
	color: ${style?.primaryTextColor ?? '#333'};
	
`);


export const OriginalPrice = styled.del<any>(
({ theme: { general, components: {price: style} } }) => css`
	${Helpers.clamp('font-size', 1, 1.15)};
	line-height: 1;
	font-weight: 400;
	color: ${style?.primaryTextColor ?? '#333'};
`);


export const PricePerUnit = styled.small<any>(
({ visible, theme: { general, components: {price: style} } }) => css`
	position: absolute;
	bottom: ${-1 * (0.5 + 1)}em; // line-height + spacing-top
	right: 0;
	width: 100%;
	overflow: hidden;
	${Helpers.clamp('font-size', 0.75, 0.95, 3.5)};

	div {
		width: fit-content;
		width: intrinsic;
		display: inline-block;
		opacity: ${visible ? 1 : 0};
		transform: translateX(${visible ? 0 : 100}%);
		transition: all ${general.transition.duration} ${general.transition.timingFunction};
	}
	
	strong {
		font-weight: 400;
		margin-right: .15em;
	}
	
	${OriginalPrice} {
		font-size: 1em;
		color: ${style.secondaryTextColor};
		margin-right: 0.25em;
	}

	${CurrentPrice} {
		font-size: 1em;
		color: ${style.primaryTextColor};
		text-decoration: none;
	}
`);


export const CurrencySymbol = styled.span<any>(
	({ position, theme: { general, components: {price: style} } }) => css`
	${`margin-${position === 'after' ? 'left' : 'right'}`}: 0.15em;
`)


const priceDisplayMap: any = {
	current: CurrentPrice,
	original: OriginalPrice
}


export const DisplayPrice = ({type, children, currency: {position, symbol}}: any) => {

	const PriceWrapper = React.useMemo(() => (type in priceDisplayMap) ? priceDisplayMap[type] : priceDisplayMap.current, [type]);

	return (
		<PriceWrapper>
			{symbol && position === 'before' && <CurrencySymbol {...{position}}>{symbol}</CurrencySymbol>}
			<span>{ children }</span>
			{symbol && position !== 'before' && <CurrencySymbol {...{position}}>{symbol}</CurrencySymbol>}
		</PriceWrapper>
	)

}